import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useEffect, useState } from 'react';

import styles from './BannerNotification.scss';

interface Props extends Partial<ClassNameProp> {
  position: string;
}

const BannerNotification: React.FC<React.PropsWithChildren<Props>> = ({
  position,
  className,
  children
}) => {
  const [showBanner, setShowBanner] = useState(false);
  // show banners on client only
  useEffect(() => setShowBanner(true), [setShowBanner]);

  return showBanner ? (
    <div
      className={classNames(
        styles.bannerNotification,
        styles[position as keyof typeof styles],
        className
      )}
    >
      {children}
    </div>
  ) : null;
};

export default BannerNotification;
